import React from 'react';
import { useTheme } from '../../context/ThemeContext';

interface SoftLoadProps {
  message?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * SoftLoad - A subtle, non-obtrusive loading indicator
 *
 * Use this instead of full-page loading overlays for:
 * - Tab switches
 * - Post submissions
 * - Feed refreshes
 * - Any loading state where the user should still see the page
 *
 * For initial page loads, continue using LoadingScreen.tsx
 */
export default function SoftLoad({
  message = 'Loading...',
  className = '',
  style = {}
}: SoftLoadProps) {
  const { theme } = useTheme();

  return (
    <div
      className={`text-center py-12 ${className}`}
      style={{
        color: theme.textColor + '99', // 60% opacity
        fontSize: '16px',
        ...style
      }}
    >
      {message}
    </div>
  );
}
